import { useState } from 'react';
import ClassNames from '@streamloots/classnames';
import { TranslateInterface } from 'utils/translation';
import Button from 'ui-library/button';
import { InputText } from 'ui-library/form-elements';
import AvatarImage from 'components/avatar-image';
import { useFeedComments } from './useFeedComments';
import theme from './feed-comments.scss';

const classNames = ClassNames(theme);

export const AddComment = ({ t }: TranslateInterface): JSX.Element | null => {
  const [comment, setComment] = useState('');
  const { user, isCreating, handleAddComment } = useFeedComments();

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value);
  };

  const handleSend = async () => {
    if (!comment) {
      return;
    }

    const result = await handleAddComment(comment);
    if (result) {
      setComment('');
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div className={classNames('feed-comments__add')}>
      <AvatarImage src={user.profile.avatarImageUrl} className={classNames('feed-comments__avatar')} />
      <InputText
        placeholder={t('pageFeed:feedDetail.comments.addComment')}
        className={classNames('feed-comments__add__input')}
        value={comment}
        onChange={handleCommentChange}
        ariaLabel={t('pageFeed:feedDetail.comments.addComment')}
      />
      <Button
        label={t('pageFeed:feedDetail.comments.send')}
        ariaLabel={t('pageFeed:feedDetail.comments.sendComment')}
        onClick={handleSend}
        variant="filled"
        color="white"
        size="sm"
        disabled={!comment}
        loading={isCreating}
      />
    </div>
  );
};
